import React, { useEffect, useState, useCallback } from 'react';
import { store } from '../../../lib/store'; // assuming you have a Redux store
import { connect } from 'react-redux';

let buildContent = (url, color) => {
    let colorMarker
    const hasSpaces = url && url.includes(' ');
    const imageUrl = hasSpaces ? url.replace(/\s/g, '%20') : url;
    if (color) {
        if (color.length <= 6 || color.length <= 7) {
            colorMarker = color[0] == '#' ? color : '#' + color;
        } else {
            colorMarker = color[0] == '#' ? color.substring(2) : '#' + color.substring(2);
        }
    } else {
        colorMarker = '#9ECC3B';
    }

    const content = document.createElement("div");
    content.innerHTML = `
        <svg class="default-size" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs>
                <clipPath id="circleClip">
                    <circle cx="8" cy="6" r="5" />
                </clipPath>
            </defs>
            <rect width="16" height="16" id="icon-bound" fill="none"></rect>
            <path
                d="M8,0C4.688,0,2,2.688,2,6c0,6,6,10,6,10s6-4,6-10C14,2.688,11.312,0,8,0z M8,8C6.344,8,5,6.656,5,5s1.344-3,3-3s3,1.344,3,3 S9.656,8,8,8z"
                fill=${colorMarker}></path>
            <circle class="" cx="8" cy="6" r="5" fill="#FFFFFF"></circle>
            <image xlink:href=${imageUrl ? imageUrl : 'https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Location.svg'}
             x="4" y="1.5" width="7" height="9" clip-path="url(#circleClip)"></image>
        </svg>
        `;
    return content;
}

//optimized code 
const updateItems = (currentItems, previousItems, setPreviousItems, type, buildContent) => {
    const newItemsMap = new Map(); // New map to store updated items

    currentItems.forEach(item => {
        const itemId = item.id;
        let existingItem = previousItems.get(itemId);

        // Common logic for all types
        if (!existingItem) {
            // Create a new item based on type
            // if (type === 'marker' || type === 'photoMarker') {
            //     const iconUrl = type === 'photoMarker' ? (item.imageUrl || 'https://example.com/default-photo-icon.svg') : item.iconUrl;
            //     const markerContent = buildContent(iconUrl, item.color);
            //     // Add logic to display this marker on the map
            //     // For example: mapObject.addMarker(markerContent);
            // } else if (type === 'polygon') {
            //     let mapObject = item.mapObj(); // Ensure mapObj exists
            //     mapObject.setPath(item.coordinates);
            //     mapObject.setOptions({ fillColor: item.color });
            // } else if (type === 'circle') {
            //     let mapObject = item.mapObj();
            //     mapObject.setCenter(item.center);
            //     mapObject.setRadius(item.radius);
            //     mapObject.setOptions({ fillColor: item.color });
            // } else if (type === 'line') {
            //     let mapObject = item.mapObj();
            //     const geoJsonData = JSON.parse(item.geoJson);
            //     let coordinates = geoJsonData.features[0].geometry.coordinates.map(coord => ({ lat: coord[1], lng: coord[0] }));
            //     const lineProperties = geoJsonData.features[0].properties.line;
            //     mapObject.setPath(coordinates);
            //     mapObject.setOptions({
            //         strokeColor: lineProperties.color || '#000000',
            //         strokeWeight: lineProperties.width || 2,
            //     });
            // }
        } else {
            // Update existing items with type-specific logic
            if (type === 'marker' || type === 'photoMarker') {
                const prevLat = existingItem.lantitude;
                const prevLng = existingItem.longitute;
                const prevColor = existingItem.color;
                const prevIconUrl = existingItem.iconUrl;

                if (prevLat !== item.lantitude || prevLng !== item.longitute || prevColor !== item.color || prevIconUrl !== item.iconUrl) {
                    let mapObject = item.mapObj();
                    mapObject.position = { lat: item.lantitude, lng: item.longitute };
                    mapObject.content = buildContent(item.iconUrl, item.color);
                }
            } else if (type === 'polygon') {
                const prevCoords = JSON.stringify(existingItem.coordinates);
                const newCoords = JSON.stringify(item.coordinates);
                const prevColor = existingItem.color;
                const newColor = item.color;
                const prevGeoJson = existingItem.geoJson;
                const newGeoJson = item.geoJson;
                if (prevCoords !== newCoords || prevColor !== newColor || prevGeoJson !== newGeoJson) {
                    let mapObject = item.mapObj();
                    mapObject.setPath(item.coordinates);
                    mapObject.setOptions({ fillColor: item.color });
                }
            } else if (type === 'circle') {
                const prevCenter = JSON.stringify(existingItem.center);
                const newCenter = JSON.stringify(item.center);
                const prevRadius = existingItem.radius;
                const newRadius = item.radius;
                const prevColor = existingItem.color;
                const newColor = item.color;
                const prevGeoJson = existingItem.geoJson;
                const newGeoJson = item.geoJson;

                if (prevCenter !== newCenter || prevRadius !== newRadius || prevColor !== newColor || prevGeoJson !== newGeoJson) {
                    let mapObject = item.mapObj();
                    mapObject.setCenter(item.center);
                    mapObject.setRadius(item.radius);
                    mapObject.setOptions({ fillColor: item.color });
                }
            } else if (type === 'line') {
                const prevPath = JSON.stringify(existingItem.path);
                const geoJsonData = JSON.parse(item.geoJson);
                let coordinates = geoJsonData.features[0].geometry.coordinates.map(coord => ({ lat: coord[1], lng: coord[0] }));
                const newPath = JSON.stringify(coordinates);
                const prevColor = existingItem.color;
                const newColor = geoJsonData.features[0].properties.line.color;
                const prevGeoJson = existingItem.geoJson;
                const newGeoJson = item.geoJson;

                if (prevPath !== newPath || prevColor !== newColor || prevGeoJson !== newGeoJson) {
                    let mapObject = item?.mapObj();
                    mapObject?.setPath(coordinates);
                    mapObject?.setOptions({
                        strokeColor: geoJsonData.features[0].properties.line.color || '#000000',
                        strokeWeight: geoJsonData.features[0].properties.line.width || 2,
                    });
                }
            }
        }

        newItemsMap.set(itemId, item);
    });

    // Remove items that no longer exist
    previousItems.forEach((item, itemId) => {
        if (!newItemsMap.has(itemId)) {
            if (item.mapObj()) {
                item.mapObj().setMap(null); // Remove from map
            }
            // Special case for 'photoMarker' type (ensure mapObj is removed)
            if ((type === 'photoMarker' || type === 'marker') && item.mapObj()) {
                item.mapObj().map = null; // Explicitly set the map to null for photoMarker
            }
        }
    });

    // Update the previous items state
    setPreviousItems(newItemsMap);
};

const MapMarkersUpdater = (props) => {
    // State to hold previous markers and other map-related items
    const [previousMarkers, setPreviousMarkers] = useState(new Map());
    const [previousPhotoMarkers, setPreviousPhotoMarkers] = useState(new Map());
    const [previousPolygons, setPreviousPolygons] = useState(new Map());
    const [previousCircles, setPreviousCircles] = useState(new Map());
    const [previousLines, setPreviousLines] = useState(new Map());

    // Memoized callback to update all items
    const updateAll = useCallback(() => {
        // Call the updateItems function for each type of map object
        updateItems(props.markers, previousMarkers, setPreviousMarkers, 'marker', buildContent);
        updateItems(props.photos, previousPhotoMarkers, setPreviousPhotoMarkers, 'photoMarker', buildContent);
        updateItems(props.polygons, previousPolygons, setPreviousPolygons, 'polygon', buildContent);
        updateItems(props.circles, previousCircles, setPreviousCircles, 'circle', buildContent);
        updateItems(props.lines, previousLines, setPreviousLines, 'line', buildContent);
    }, [previousMarkers, previousPhotoMarkers, previousPolygons, previousCircles, previousLines, props]);

    // Fetch updates at regular intervals and update items
    useEffect(() => {
        const intervalId = setInterval(() => {
            console.log('=======auto call map objects api======')
            props.fetchChanges(); // Fetch changes every 15 seconds
            updateAll();
        }, 1000 * 60 * 2.5); // Set to 15 seconds interval

        return () => clearInterval(intervalId); // Cleanup on unmount
    }, [updateAll, props]);

    return null; // This component doesn't render anything
};

const mapStateToProps = (state) => ({
    markers: state.markers,
    photos: state.photos,
    circles: state.circles,
    lines: state.lines,
    polygons: state.polygons,
});

export default connect(mapStateToProps)(MapMarkersUpdater);

//old code
// import React, { useEffect, useState } from 'react';
// import { store } from '../../../lib/store'; // assuming you have a Redux store
// import { connect } from 'react-redux'

// const MapMarkersUpdater = (props) => {
//     const [previousMarkers, setPreviousMarkers] = useState(new Map()); // Store markers by id
//     const [previousPhotoMarkers, setPreviousPhotoMarkers] = useState(new Map()); // Store photo markers by id
//     const [previousPolygons, setPreviousPolygons] = useState(new Map()); // Store polygons by id
//     const [previousCircles, setPreviousCircles] = useState(new Map()); // Store circles by id
//     const [previousLines, setPreviousLines] = useState(new Map()); // Store lines by id

//     const updateMarkers = () => {
//         let reducStore = store.getState();
//         const currentMarkers = reducStore.markers;
//         // props.fetchChanges();
//         // Create a new map to store the updated markers
//         const newMarkersMap = new Map();

//         // Loop through current markers and update them
//         currentMarkers.forEach(element => {
//             const markerId = element.id;
//             let existingMarker = previousMarkers.get(markerId);
//             if (!existingMarker) {
//                 // Create or update the marker content
//                 const markerContent = buildContent(element.iconUrl, element.color);
//             } else {
//                 const previousLat = existingMarker.lantitude;
//                 const previousLng = existingMarker.longitute;
//                 const previousCOlor = existingMarker.color;

//                 if (previousLat !== element.lantitude || previousLng !== element.longitute || previousCOlor !== element.color) {
//                     // If the position has changed, update the marker's position and content
//                     let mapObject = element.mapObj();
//                     mapObject.position = { lat: element.lantitude, lng: element.longitute };
//                     mapObject.content = buildContent(element.iconUrl, element.color);
//                 }
//             }
//             // Add the marker to the new markers map
//             newMarkersMap.set(markerId, element);
//         });

//         // Remove markers that no longer exist
//         previousMarkers.forEach((marker, markerId) => {
//             if (!newMarkersMap.has(markerId)) {
//                 // Marker no longer exists, remove it from the map
//                 if (marker.mapObj()) {
//                     marker.mapObj().map = null; // Assuming `map = null` removes it
//                 }
//             }
//         });

//         // Update the state of previousMarkers
//         setPreviousMarkers(newMarkersMap);
//     };

//     const updatePhotoMarkers = () => {
//         let reducStore = store.getState();
//         const currentPhotos = reducStore.photos;
//         // props.fetchChanges();
//         // Create a new map to store the updated photo markers
//         const newPhotoMarkersMap = new Map();

//         // Loop through current photos and update them
//         currentPhotos.forEach(photo => {
//             const photoId = photo.id;
//             let existingMarker = previousPhotoMarkers.get(photoId);
//             if (!existingMarker) {
//                 // Create or update the photo marker content with photo-specific icon
//                 const iconUrl = photo.imageUrl ? photo.imageUrl : 'https://example.com/default-photo-icon.svg';
//                 const markerContent = buildContent(iconUrl, photo.color);
//                 // Add logic to display this photo marker on the map
//             }
//             else {
//                 const previousLat = existingMarker.lantitude;
//                 const previousLng = existingMarker.longitute;
//                 const previousCOlor = existingMarker.color;

//                 if (previousLat !== photo.lantitude || previousLng !== photo.longitute || previousCOlor !== photo.color) {
//                     // If the position has changed, update the marker's position and content
//                     let mapObject = photo.mapObj();
//                     mapObject.position = { lat: photo.lantitude, lng: photo.longitute };
//                     mapObject.content = buildContent(photo.iconUrl, photo.color);
//                 }
//             }
//             // Add the photo marker to the new photo markers map
//             newPhotoMarkersMap.set(photoId, photo);
//         });

//         // Remove photo markers that no longer exist
//         previousPhotoMarkers.forEach((photoMarker, photoId) => {
//             if (!newPhotoMarkersMap.has(photoId)) {
//                 // Photo marker no longer exists, remove it from the map
//                 if (photoMarker.mapObj()) {
//                     photoMarker.mapObj().map = null;
//                 }
//             }
//         });

//         // Update the state of previousPhotoMarkers
//         setPreviousPhotoMarkers(newPhotoMarkersMap);
//     };

//     const updatePolygons = () => {
//         const currentPolygons = props.polygons; // Updated values from props
//         const newPolygonsMap = new Map(); // New map to hold updated polygons

//         // Loop through currentPolygons and store in newPolygonsMap
//         currentPolygons.forEach(polygon => {
//             const polygonId = polygon.id;
//             let existingPolygon = previousPolygons.get(polygonId);

//             if (!existingPolygon) {
//                 // Create new polygon logic
//                 let mapObject = polygon.mapObj(); // Ensure mapObj exists
//                 mapObject.setPath(polygon.coordinates);
//                 mapObject.setOptions({ fillColor: polygon.color });
//             } else {
//                 const prevCoords = JSON.stringify(existingPolygon.coordinates);
//                 const newCoords = JSON.stringify(polygon.coordinates);
//                 const prevColor = existingPolygon.color;
//                 const newColor = polygon.color;

//                 // Enhanced comparison logic
//                 if (prevCoords !== newCoords || prevColor !== newColor) {
//                     let mapObject = polygon.mapObj();
//                     mapObject.setPath(polygon.coordinates);
//                     mapObject.setOptions({ fillColor: polygon.color });
//                 } else {

//                 }
//             }

//             newPolygonsMap.set(polygonId, polygon);
//         });
//         // Loop through previousPolygons to find and remove those not present in newPolygonsMap
//         previousPolygons.forEach((polygon, polygonId) => {
//             if (!newPolygonsMap.has(polygonId)) {
//                 if (polygon.mapObj()) {
//                     polygon.mapObj().setMap(null); // Remove from the map
//                 }
//             } else {
//             }
//         });

//         setPreviousPolygons(newPolygonsMap);
//     };

//     const updateCircles = () => {
//         const currentCircles = props.circles; // Updated values from props
//         const newCirclesMap = new Map(); // New map to hold updated circles

//         // Loop through currentCircles and store in newCirclesMap
//         currentCircles.forEach(circle => {
//             const circleId = circle.id;
//             let existingCircle = previousCircles.get(circleId);

//             if (!existingCircle) {
//             } else {
//                 const prevCenter = JSON.stringify(existingCircle.center);
//                 const newCenter = JSON.stringify(circle.center);
//                 const prevRadius = existingCircle.radius;
//                 const newRadius = circle.radius;
//                 const prevColor = existingCircle.color;
//                 const newColor = circle.color;

//                 // Enhanced comparison logic
//                 if (prevCenter !== newCenter || prevRadius !== newRadius || prevColor !== newColor) {
//                     let mapObject = circle.mapObj();
//                     mapObject.setCenter(circle.center);
//                     mapObject.setRadius(circle.radius);
//                     mapObject.setOptions({ fillColor: circle.color });
//                 } else {

//                 }
//             }

//             newCirclesMap.set(circleId, circle);
//         });

//         // Loop through previousCircles to find and remove those not present in newCirclesMap
//         previousCircles.forEach((circle, circleId) => {
//             if (!newCirclesMap.has(circleId)) {
//                 if (circle.mapObj()) {
//                     circle.mapObj().setMap(null); // Remove from the map
//                 }
//             } else {

//             }
//         });

//         // Update the state with the new circles map
//         setPreviousCircles(newCirclesMap);
//     };

//     const updateLines = () => {
//         const currentLines = props.lines; // Updated values from props
//         const newLinesMap = new Map(); // New map to hold updated lines

//         // Loop through currentLines and store in newLinesMap
//         currentLines.forEach(line => {
//             const lineId = line.id;
//             let existingLine = previousLines.get(lineId);

//             // Parse the geoJson if provided
//             const geoJsonData = JSON.parse(line.geoJson);
//             let coordinates = geoJsonData.features[0].geometry.coordinates; // Extract coordinates
//             coordinates = coordinates.map(coord => ({ lat: coord[1], lng: coord[0] }));

//             const lineProperties = geoJsonData.features[0].properties.line; // Extract properties like color, width

//             if (!existingLine) {
//             } else {
//                 const prevPath = JSON.stringify(existingLine.path);
//                 const newPath = JSON.stringify(coordinates);
//                 const prevColor = existingLine.color;
//                 const newColor = lineProperties.color;

//                 // Enhanced comparison logic
//                 if (prevPath !== newPath || prevColor !== newColor) {
//                     let mapObject = line.mapObj();
//                     mapObject.setPath(coordinates); // Update the path with new coordinates
//                     mapObject.setOptions({
//                         strokeColor: lineProperties.color || '#000000', // Update color
//                         strokeWeight: lineProperties.width || 2, // Update width if applicable
//                     });
//                 } else {

//                 }
//             }

//             newLinesMap.set(lineId, line);
//         });

//         // Loop through previousLines to find and remove those not present in newLinesMap
//         previousLines.forEach((line, lineId) => {
//             if (!newLinesMap.has(lineId)) {
//                 if (line.mapObj()) {
//                     line.mapObj().setMap(null); // Remove from the map
//                 }
//             } else {

//             }
//         });

//         // Update the state with the new lines map
//         setPreviousLines(newLinesMap);
//     };

//     useEffect(() => {
//         const intervalId = setInterval(() => {
//             props.fetchChanges()
//             updateMarkers();
//             updatePhotoMarkers();
//             updatePolygons();
//             updateCircles();
//             updateLines();
//         }, 1000 * 60 * 1 / 4); // Adjust the interval as needed
//         return () => clearInterval(intervalId); // Cleanup on unmount
//     }, [previousMarkers, previousPhotoMarkers, previousPolygons, previousCircles, previousPolygons, previousLines])
//     return null; // This component doesn't render anything visually
// };

// const mapStateToProps = state => ({
//     userSettings: state.userSettings,
//     loading: state.loading,
//     layersDictionary: state.layersDictionary,
//     markers: state.markers,
//     photos: state.photos,
//     circles: state.circles,
//     lines: state.lines,
//     polygons: state.polygons,
//     lines: state.lines
// });

// const mapDispatchToProps = dispatch => ({
//     // Add necessary dispatch actions if required
// });

// export default connect(mapStateToProps, mapDispatchToProps)(MapMarkersUpdater);



